import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { LocationType } from "app/_models/location-type.model";
import { environment } from "environments/environment";
import { CommonService } from "app/reusable/common.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CedNotificationService } from "ced-ng-library";

@Component({
  selector: "app-location-types-list",
  templateUrl: "./location-types-list.component.html",
  styleUrls: ["./location-types-list.component.scss"],
})
export class LocationTypesListComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() locations: LocationType[];
  @Input() rehospitalisationValue :boolean = false;
  public serverUrlSlot1 : string = environment.Services.AlphaURLSlot1;
  showGrid = true;
  gridData: LocationType[] = [];
  caseTypeLocations :any[] =[]
  public AddDialogOpened = false;
  public UpdateDialogOpened = false;
  public DeleteDialogOpened = false;
  @Output() locationsChanged = new EventEmitter();
  @Output() locationGrid = new EventEmitter();
  SelectedLocationslist = [];
  public list: any[] = [];
  public usedLocation = false;
  data = [];
  status = [];
  private _subject$: Subject<boolean> = new Subject();
  selectedLocation;

  constructor(private CommonService: CommonService,
    private cedNotificationService: CedNotificationService) { }

  ngOnInit() {
    this.loadLocations();
  }

  ngOnChanges() {}

  ngOnDestroy(): void {
    this._subject$.unsubscribe();
  }

  loadLocations(): void {
    let getLocationsUrl: string = `Location/GetAll`;
    let getCaseTypeLocationUrl: string = `CaseType/GetAllCaseTypeLocation`;
    this.CommonService.getData(getLocationsUrl, this.serverUrlSlot1).pipe(takeUntil(this._subject$)).subscribe((data: any) => {
      this.gridData = data;
      this.CommonService.getData(getCaseTypeLocationUrl,this.serverUrlSlot1).pipe(takeUntil(this._subject$)).subscribe((dataSource: any) => {
        this.caseTypeLocations = dataSource;
      this.gridData.forEach((el) => {
        if (this.locations.some((l) => l.lctId == el.lctId)) {
          el.lctIsSelected = true;
        } else {
          el.lctIsSelected = false;
        }
      });
    });
    });
  }

  openDetails(component) { 
    if(this.selectedLocation != null)
    this.open(component,this.selectedLocation);
    this.selectedLocation = null; 
  }
 
  onCellClick($event) {
    this.selectedLocation = $event.dataItem
  }
  deleteitem;
  edititem;
  locNamesList;
  public open(component, ToSend) {
    if( component ==  "DeleteDialog"){
      this[component + "Opened"] = true;
      this.caseTypeLocations.forEach(element => {
        if (ToSend.lctId == element.lctId){
          this[component + "Opened"] = false;
          this.cedNotificationService.warning("NOTIFICATIONS.CAN_NOT_DELETE_USED_LOCATION");
        }
      });
  }
  else if(component !=  "DeleteDialog"){
    this[component + "Opened"] = true;
  }
    this.edititem = ToSend == null ? new LocationType() : ToSend;
    this.deleteitem = ToSend;
    this.locNamesList = this.list;
  }

  public save(event) {
    this.AddDialogOpened = false;
    if (event != null) {
      if (event.add == false) {
        let index = this.gridData.findIndex(el => el.lctId == event.location.lctId);
        if (index != -1) {
          this.gridData[index] = event.location;
        }
      }
      else if (event.add == true) {
        this.gridData.push(event.location);
      }
      this.gridData = [...this.gridData];
      this.syncData(null);
    }
  }

  delete(event) {
    this.DeleteDialogOpened = event.dialogstatus;
    if (event.lctId !== null) {
      this.gridData = this.gridData.filter(e => e.lctId !== event.lctId);
      this.gridData = [...this.gridData];
      this.syncData(null);
    }
   
  }

  syncData(event): void {
    this.locationsChanged.emit(
      this.gridData.filter((e) => e.lctIsSelected == true)
    );
  }
}